import { get } from './Api'

// Debt Batches API Service Functions

/**
 * Get debt summary for the business
 * @returns Promise with debt summary data
 */
export const getDebtSummary = async () => {
  try {
    const response = await get('business/debt-batches/summary')
    return response
  } catch (error) {
    throw error
  }
}

/**
 * Get paginated list of debt batches
 * @param status - Filter by status: 'active', 'pending', 'overdue', 'cleared', 'all'
 * @param page - Page number (default: 1)
 * @param limit - Items per page (default: 10)
 * @returns Promise with debt batches data
 */
export const getDebtBatches = async (
  status: string = 'active',
  page: number = 1,
  limit: number = 10,
) => {
  try {
    const response = await get(
      `business/debt-batches?status=${status}&page=${page}&limit=${limit}`,
    )
    return response
  } catch (error) {
    throw error
  }
}

/**
 * Get single debt batch by ID
 * @param batchId - The batch ID
 * @returns Promise with debt batch data
 */
export const getDebtBatchById = async (batchId: string) => {
  try {
    const response = await get(`business/debt-batches/${batchId}`)
    return response
  } catch (error) {
    throw error
  }
}
